import { CARIS_MDP_SLUG } from 'utils/constants/products';

/**
 * Product page href. Caris Detect is an MDP at `/{slug}`; catalog products use
 * `/products/{slug}`.
 */
export const getProductHref = (slug: string): string => {
  if (slug === CARIS_MDP_SLUG) {
    return `/${CARIS_MDP_SLUG}`;
  }
  return `/products/${slug}`;
};
